import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function About() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <div style={{ padding: "2rem" }}>
            <Link to="/" className="safe-top-link">
    ← Home
</Link>

            <h1>About Figure It Out</h1>

            <p>
                Figure It Out is a collection of interactive
                activities designed to develop practical
                thinking skills that people can use in
                everyday life.
            </p>

            <p>
                The activities are primarily designed for
                older teenagers and young adults, but
                anyone who enjoys learning through
                interactive challenges is welcome to
                explore them.
            </p>

            <p>
                Topics include observation, memory,
                communication, emotional intelligence,
                critical thinking, decision making,
                problem solving and metacognition.
            </p>

            <p>
                Rather than focusing on memorising facts,
                Figure It Out aims to help users think more
                clearly, communicate more effectively and
                make better decisions in real-world
                situations.
            </p>
        </div>
    );
}